"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _noop = require("../../constants/noop");
var _useTheme = require("../../theme/utils/useTheme");
var _focusMode = require("../focusMode");
var _StyledContentAfterContainer = require("./styled/StyledContentAfterContainer");
var _StyledContentBeforeContainer = require("./styled/StyledContentBeforeContainer");
var _StyledInput = require("./styled/StyledInput");
var _StyledInputContainer = require("./styled/StyledInputContainer");
var _TextInputRootBox = require("./styled/TextInputRootBox");
var _TextInputRootUnderline = require("./styled/TextInputRootUnderline");
/**
 * Used to provide the left and right customizations access to the current state of the TextInput.
 */

// Omitting "style" because, it's ambiguous as to which sub element
// the style should go on (the input itself or the wrapper).
// Omitting "defaultValue" because we're only support controlled use
// cases right now.

const TextInput = /*#__PURE__*/(0, _react.forwardRef)((props, parentRef) => {
  const {
    contentAfter,
    contentBefore,
    className,
    value,
    onChange,
    clientId,
    variant = "box",
    type = "text",
    onFocus,
    onBlur,
    onKeyDown,
    onKeyUp,
    validationState,
    isDisabled = false,
    ...htmlAttributes
  } = props;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const [isFocused, setIsFocused] = (0, _react.useState)(false);
  const [isHovered, setIsHovered] = (0, _react.useState)(false);
  const textInputRef = (0, _lodestarUtils.useEnsuredForwardedRef)(parentRef);
  function handleOnChange(e) {
    onChange(e.target.value, e);
  }
  function handleOnFocus(e) {
    setIsFocused(true);
    if (onFocus) {
      onFocus(e);
    }
  }
  function handleOnBlur(e) {
    setIsFocused(false);
    if (onBlur) {
      onBlur(e);
    }
  }
  const handleKeyDown = (0, _lodestarUtils.useIsComposingHandler)(onKeyDown || _noop.noop);
  const handleKeyUp = (0, _lodestarUtils.useIsComposingHandler)(onKeyUp || _noop.noop);
  const OuterComponent = variant === "box" ? _TextInputRootBox.TextInputRootBox : _TextInputRootUnderline.TextInputRootUnderline;
  const {
    focusMode
  } = (0, _focusMode.useFocusMode)();
  return /*#__PURE__*/_react.default.createElement(OuterComponent, {
    isDisabled: isDisabled,
    isFocused: isFocused,
    isHovered: isHovered,
    validationState: validationState,
    className: className,
    themeMode: themeMode,
    hasContentAfter: !!contentAfter,
    focusMode: focusMode,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    onClick: () => {
      textInputRef.current?.focus();
    }
  }, contentBefore && /*#__PURE__*/_react.default.createElement(_StyledContentBeforeContainer.StyledContentBeforeContainer, {
    themeMode: themeMode,
    validationState: validationState,
    isFocused: isFocused,
    variant: variant
  }, typeof contentBefore === "function" ? contentBefore({
    isFocused,
    isHovered
  }) : contentBefore), /*#__PURE__*/_react.default.createElement(_StyledInputContainer.StyledInputContainer, null, /*#__PURE__*/_react.default.createElement(_StyledInput.StyledInput, (0, _extends2.default)({
    variant: variant,
    themeMode: themeMode,
    type: type,
    value: value,
    onChange: handleOnChange,
    focusMode: focusMode,
    ref: textInputRef,
    "data-client-id": clientId,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    onKeyDown: onKeyDown && handleKeyDown || undefined,
    onKeyUp: onKeyUp && handleKeyUp || undefined,
    isHovered: isHovered,
    "aria-disabled": isDisabled,
    isFocused: isFocused
  }, htmlAttributes, {
    readOnly: isDisabled ? true : htmlAttributes.readOnly ? htmlAttributes.readOnly : false,
    hasContentAfter: !!contentAfter,
    hasContentBefore: !!contentBefore,
    validationState: validationState
  }))), contentAfter && /*#__PURE__*/_react.default.createElement(_StyledContentAfterContainer.StyledContentAfterContainer, {
    themeMode: themeMode,
    validationState: validationState,
    isFocused: isFocused,
    focusMode: focusMode
  }, typeof contentAfter === "function" ? contentAfter({
    isFocused,
    isHovered
  }) : contentAfter));
});
exports.TextInput = TextInput;
TextInput.displayName = "TextInput";
//# sourceMappingURL=TextInput.js.map